export const locale = {
  lang: "en-CA",
  data: {
    ORG: {
      GRAPHICS: "Graphics",
      LOGO: "Logo",
      UPLOAD_LOGO: "Upload Logo",
      UPLOAD_LOGO_SUCCESS: "Logo uploaded successfully",
      UPLOAD_LOGO_DIMENSION: "minimum width & height: 200px",
      UPLOAD_HEADER: "Upload Header",
      UPLOAD_HEADER_SUCCESS: "Header uploaded successfully",
      UPLOAD_HEADER_DIMENSION: "minimum width: 600, minimum height: 120px",
      SELECT_LOCALES: "Select one or more languages this organization want to use from the list below.",
      SELECT_DEFAULT_LOCALES: "Select default language for this organization",
      CURRENT_LOGO: "Current Logo",
      CURRENT_REPORT_HEADER: "Current Reports Header",
      CURRENT_REPORT_ASSETS: "Other Reports Assets",
      NEXT_PAYMENT_DATE: "Next payment date",
      OPEN_SINCE: "Open since",
      TOTAL_USER: "Total paying user",
      CURRENT_COST: "Monthly current cost",
      RESPONSIBLE_USER: "Responsible user",
      ORG_LIST: "List of caterer",
      TRIAL: "Trial",
      SUPPORT_EMAIL: "Email support",
      SUPPORT_TEL: "Telephone support",
      SIGNATURE: "Signature",
      LOGO_WHITE: "Logo White",
      LOGO_COLOR: "Logo Color",
      UPLOAD_LOGO_TYPE: "Upload",
      UPLOAD_LOGO_TYPE_SUCCESS: "Logo uploaded successfully",
      UPLOAD_LOGO_TYPE_ERROR: "Error uploading logo",
      LOGO_PNG_ONLY: "PNG only, 272x72 pixels",
      LOGO_INVALID_DIMENSIONS: "Image must be 272x72 pixels",
      LOGO_INVALID_FORMAT: "Only PNG files are accepted",
      PRODUCT_DEFAULT_IMAGE: "Default product image",
      PRODUCT_DEFAULT_PNG_ONLY: "PNG only, 250x250 pixels",
      PRODUCT_DEFAULT_INVALID_DIMENSIONS: "Image must be 250x250 pixels",
      PRODUCT_DEFAULT_UPLOAD_SUCCESS: "Image uploaded successfully",
      PRODUCT_DEFAULT_UPLOAD_ERROR: "Error uploading image",
      COLORS: "Colors",
      MANAGE_TAX_NUMBERS: "Tax numbers management",
      EMAIL_BG_COLOR: "Email header color",
      EMAIL_BG_COLOR_HELP:
        "Color of the header/footer band and primary buttons in the emails sent. Leave empty to use the default color.",
      EMAIL_BG_COLOR_CLEAR: "Clear",
      EMAIL_BG_COLOR_SAVED: "Email header color saved",
      IDENTITIES: "Organization identities",
      IDENTITY_ADD: "Add an identity",
      IDENTITY_EDIT: "Edit identity",
      IDENTITY_NAME: "Name",
      IDENTITY_THEME_COLOR: "Theme color",
      IDENTITY_EMAIL_BG_COLOR: "Email header color",
      IDENTITY_EMAIL_BG_COLOR_HELP:
        "If empty, the parent organization color is used.",
      IDENTITY_EMPTY: "No identity",
      IDENTITY_SAVE_FIRST: "Save the identity first to upload logos.",
      IDENTITY_CREATE_SUCCESS: "Identity created successfully",
      IDENTITY_UPDATE_SUCCESS: "Identity updated successfully",
      IDENTITY_DELETE_SUCCESS: "Identity deleted successfully",
      IDENTITY_NEW: "New identity",
      IDENTITY_TITLE: "Organization identity",
      IDENTITY_COLORS: "Colors",
      IDENTITY_NOT_FOUND: "Identity not found",
    },
  },
};
